interface ConfigLoadFailure {
    type: string;
    source: string;
}

// Diagnostic metadata only: never controls analytics readiness or widget display.
// Keep hosts separate so a preview/config override cannot mislabel the host page.
const failures = new Map<string, ConfigLoadFailure>();

export function setConfigLoadFailure(domain: string, failure: ConfigLoadFailure | null): void {
    if (failure) failures.set(domain, failure);
    else failures.delete(domain);
}

export function getConfigLoadFailure(domain: string): Readonly<ConfigLoadFailure> | undefined {
    return failures.get(domain);
}
